var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_119_29)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.97,
    y: 18.04,
    width: 30,
    height: 30,
    rx: 15,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.97,
    y: 18.04,
    width: 30,
    height: 30,
    rx: 15,
    fill: "url(#pattern0)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_119_29",
    x: 0.969971,
    y: 0.0400391,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_119_29"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_119_29",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_119_29",
    transform: "translate(0.25 0.25) scale(0.00961538)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_119_29",
    width: 52,
    height: 52,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDone);
export default __webpack_public_path__ + "static/media/Home_Done.a1f4d2a366a7ccd0f537c31d4a06ed38.svg";
export { ForwardRef as ReactComponent };